export default __webpack_public_path__ + "static/media/no-races.6afc25ce.png";